import React from 'react';

import BaseComponentProperty from "../index";
import Style from "../Style";

export default class DragAndDropPuzzle extends BaseComponentProperty {
    hasQuestionNumber() {
        return true;
    }

    renderAnswerOptions() {
        return (
            <div>
                <a data-bs-toggle="collapse" href={"#collapseAnswerOptions"} aria-expanded="false"
                   aria-controls="collapseAnswerOptions">
                    <h5>Answer Options</h5>
                </a>
                <div className="collapse" id="collapseAnswerOptions">
                    <button className='button mb-2' onClick={() => {
                        let data = this.props.component.data;
                        let answer_options = data.answer_options;
                        answer_options.push({
                            dnd_id: "option-",
                            draggable_style: {},
                            content: {
                                html: '',
                                text: ''
                            }
                        });
                        data.answer_options = answer_options;
                        this.props.onChange('data', data);
                    }}>+ option
                    </button>
                    <div>
                        {this.props.component.data.answer_options.map((item, index) => {
                            return (
                                <div key={index} style={{position: 'relative'}} className='bordered mb-2'>
                                    <i
                                        className='fas fa-trash text-danger clickable'
                                        style={{position: 'absolute', right: '0', top: '5px'}}
                                        onClick={() => {
                                            let data = this.props.component.data;
                                            data.answer_options.splice(index, 1);
                                            this.props.onChange('data', data);
                                        }}
                                    />
                                    <div className='d-flex flex-row flex-wrap flex-box-0-5'>
                                        <div>
                                            <label>DnD ID</label>
                                            <input
                                                type='text'
                                                value={item.dnd_id ? item.dnd_id : ''}
                                                onChange={event => {
                                                    let data = this.props.component.data;
                                                    let answer_options = data.answer_options;
                                                    item.dnd_id = event.target.value;
                                                    answer_options[index] = item;
                                                    data.answer_options = answer_options;
                                                    this.props.onChange('data', data);
                                                }}
                                            />
                                        </div>
                                        <div>
                                            <label>Html</label>
                                            <input
                                                type='text'
                                                value={item.content && item.content.html ? item.content.html : ''}
                                                onChange={event => {
                                                    let data = this.props.component.data;
                                                    let answer_options = data.answer_options;
                                                    if (!item.content) {
                                                        item.content = {}
                                                    }
                                                    item.content.html = event.target.value;
                                                    answer_options[index] = item;
                                                    data.answer_options = answer_options;
                                                    this.props.onChange('data', data);
                                                }}
                                            />
                                        </div>
                                        <div>
                                            <label>Text</label>
                                            <input
                                                type='text'
                                                value={item.content && item.content.text ? item.content.text : ''}
                                                onChange={event => {
                                                    let data = this.props.component.data;
                                                    let answer_options = data.answer_options;
                                                    if (!item.content) {
                                                        item.content = {}
                                                    }
                                                    item.content.text = event.target.value;
                                                    answer_options[index] = item;
                                                    data.answer_options = answer_options;
                                                    this.props.onChange('data', data);
                                                }}
                                            />
                                        </div>
                                        <div>
                                            <label>Image</label>
                                            <input
                                                type='text'
                                                value={item.content && item.content.image ? item.content.image : ''}
                                                onChange={event => {
                                                    let data = this.props.component.data;
                                                    let answer_options = data.answer_options;
                                                    if (!item.content) {
                                                        item.content = {}
                                                    }
                                                    item.content.image = event.target.value;
                                                    answer_options[index] = item;
                                                    data.answer_options = answer_options;
                                                    this.props.onChange('data', data);
                                                }}
                                            />
                                        </div>
                                        <div>
                                            <label>Image alt</label>
                                            <input
                                                type='text'
                                                value={item.content && item.content.image_alt ? item.content.image_alt : ''}
                                                onChange={event => {
                                                    let data = this.props.component.data;
                                                    let answer_options = data.answer_options;
                                                    if (!item.content) {
                                                        item.content = {}
                                                    }
                                                    item.content.image_alt = event.target.value;
                                                    answer_options[index] = item;
                                                    data.answer_options = answer_options;
                                                    this.props.onChange('data', data);
                                                }}
                                            />
                                        </div>
                                        <Style
                                            initial={item.draggable_style}
                                            name='Draggable Style'
                                            onChange={draggable_style => {
                                                let data = JSON.parse(JSON.stringify(this.props.component.data));
                                                data.answer_options[index].draggable_style = draggable_style;
                                                this.props.onChange('data', data);
                                            }}/>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }

    renderAnswerLayoutItem(index, item) {
        return (
            <div className='d-flex flex-row flex-wrap flex-box-0-5'>
                <div>
                    <label>DnD ID</label>
                    <input
                        type='text'
                        value={item.dnd_id ? item.dnd_id : ''}
                        onChange={event => {
                            let data = this.props.component.data;
                            let answer_layout = data.answer_layout;
                            item.dnd_id = event.target.value;
                            answer_layout[index] = item;
                            data.answer_layout = answer_layout;
                            this.props.onChange('data', data);
                        }}
                    />
                </div>
                <div>
                    <label>Placeholder</label>
                    <input
                        type='text'
                        value={item.placeholder ? item.placeholder : ''}
                        onChange={event => {
                            let data = this.props.component.data;
                            let answer_layout = data.answer_layout;
                            item.placeholder = event.target.value;
                            answer_layout[index] = item;
                            data.answer_layout = answer_layout;
                            this.props.onChange('data', data);
                        }}
                    />
                </div>
                <div>
                    <label>Item position top</label>
                    <input
                        type='text'
                        value={item.item_position && item.item_position.top ? item.item_position.top : ''}
                        onChange={event => {
                            let data = this.props.component.data;
                            let answer_layout = data.answer_layout;
                            if (!item.item_position) {
                                item.item_position = {};
                            }
                            item.item_position.top = event.target.value;
                            answer_layout[index] = item;
                            data.answer_layout = answer_layout;
                            this.props.onChange('data', data);
                        }}
                    />
                </div>
                <div>
                    <label>Item position left</label>
                    <input
                        type='text'
                        value={item.item_position && item.item_position.left ? item.item_position.left : ''}
                        onChange={event => {
                            let data = this.props.component.data;
                            let answer_layout = data.answer_layout;
                            if (!item.item_position) {
                                item.item_position = {};
                            }
                            item.item_position.left = event.target.value;
                            answer_layout[index] = item;
                            data.answer_layout = answer_layout;
                            this.props.onChange('data', data);
                        }}
                    />
                </div>
                <div>
                    <label>HTML</label>
                    <textarea
                        value={item.content && item.content.html ? item.content.html : ''}
                        onChange={event => {
                            let data = this.props.component.data;
                            let answer_layout = data.answer_layout;
                            if (!item.content) {
                                item.content = {};
                            }
                            item.content.html = event.target.value;
                            answer_layout[index] = item;
                            data.answer_layout = answer_layout;
                            this.props.onChange('data', data);
                        }}
                    />
                </div>
                <div>
                    <label>Text</label>
                    <textarea
                        value={item.content && item.content.text ? item.content.text : ''}
                        onChange={event => {
                            let data = this.props.component.data;
                            let answer_layout = data.answer_layout;
                            if (!item.content) {
                                item.content = {};
                            }
                            item.content.text = event.target.value;
                            answer_layout[index] = item;
                            data.answer_layout = answer_layout;
                            this.props.onChange('data', data);
                        }}
                    />
                </div>
                <Style
                    initial={item.droppable_style}
                    name='Droppable Style'
                    onChange={droppable_style => {
                        let data = JSON.parse(JSON.stringify(this.props.component.data));
                        data.answer_layout[index].droppable_style = droppable_style;
                        this.props.onChange('data', data);
                    }}/>
            </div>
        );
    }

    renderAnswerLayout() {
        return (
            <div>
                <a data-bs-toggle="collapse" href={"#collapseAnswerLayout"} aria-expanded="false"
                   aria-controls="collapseAnswerLayout">
                    <h5>Answer Layout</h5>
                </a>
                <div className="collapse" id="collapseAnswerLayout">
                    <div className='d-flex flex-box-0-5'>
                        <button className='button mb-2' onClick={() => {
                            let data = this.props.component.data;
                            let answer_layout = data.answer_layout;
                            answer_layout.push({
                                type: "dnd",
                                dnd_id: "answer-" + Math.floor(Math.random() * 100),
                                placeholder: "",
                                item_position: {
                                    left: '',
                                    top: ''
                                },
                                droppable_style: {},
                                content: {
                                    html: '',
                                    text: ''
                                }
                            });
                            data.answer_layout = answer_layout;
                            this.props.onChange('data', data);
                        }}>+ DnD
                        </button>
                    </div>
                    <div>
                        {this.props.component.data.answer_layout.map((item, index) => {
                            return (
                                <div key={index} style={{position: 'relative'}} className='bordered mb-2'>
                                    <i
                                        className='fas fa-trash text-danger clickable'
                                        style={{position: 'absolute', right: '0', top: '5px'}}
                                        onClick={() => {
                                            let data = this.props.component.data;
                                            data.answer_layout.splice(index, 1);
                                            this.props.onChange('data', data);
                                        }}
                                    />
                                    {this.renderAnswerLayoutItem(index, item)}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }

    renderOwnProperties() {
        return (
            <div>
                {this.renderAnswerOptions()}
                {this.renderAnswerLayout()}
            </div>
        );
    }
}
